import { useSelector } from "react-redux";

import type Signal from "app/pages/sales-intelligence/sub-modules/signals/models/core/Signal";
import type SignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/core/SignalFilters";
import type SignalCreateDTO from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalCreateDTO";
import signalsValidationService from "app/pages/sales-intelligence/sub-modules/signals/services/validation/signalsValidationService";
import { selectAllDraftSignalsList } from "app/pages/sales-intelligence/sub-modules/signals/store/selectors";

type HookValue<F extends SignalFilters> = (draftSignal: SignalCreateDTO<F>) => Signal<F> | undefined;

export const useFindDuplicateSignalDraft = <F extends SignalFilters>(): HookValue<F> => {
    const allDraftSignals = useSelector(selectAllDraftSignalsList);

    return (draftSignal) => {
        const isSignalDuplicate = signalsValidationService.checkIsSignalDuplicateBy(
            draftSignal.signalType,
            draftSignal.signalSource,
        );

        const signalsOfType = allDraftSignals.filter(
            (signal) =>
                signal.signalType === draftSignal.signalType && signal.signalSource === draftSignal.signalSource,
        );

        return signalsOfType.find((signal) => isSignalDuplicate(draftSignal.filters, [signal]));
    };
};
